import type { ReactNode } from 'react';

export function SectionLabel({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 'var(--sp-3)',
        marginBottom: 'var(--sp-3)',
      }}
    >
      <span style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-body-md)' }}>{children}</span>
      {right}
    </div>
  );
}
